module.exports = __webpack_public_path__ + "img/CD-brochure.0d203401.jpg";